import { render, staticRenderFns } from "./ed-course-create-subdeck-object.vue?vue&type=template&id=a8aac202&"
import script from "./ed-course-create-subdeck-object.ts?vue&type=script&lang=ts&"
export * from "./ed-course-create-subdeck-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-create-subdeck-object.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports